import { render, staticRenderFns } from "./RedeliveryRequestList.vue?vue&type=template&id=05149433&scoped=true&"
import script from "./RedeliveryRequestList.vue?vue&type=script&lang=js&"
export * from "./RedeliveryRequestList.vue?vue&type=script&lang=js&"
import style0 from "./RedeliveryRequestList.vue?vue&type=style&index=0&id=05149433&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05149433",
  null
  
)

export default component.exports